// extracted by mini-css-extract-plugin
export default {"cautionIcon":"KYBBanner_cautionIcon__PVnQv"};